/*
 * Game Constants
 */

// -------------------- Debug

export const DEBUG_LOGS = false;
export const DEBUG_BUTTONS = false;

// -------------------- Game Mechanics

export const GUESSES = 10;
export const CANVAS_SIZE = 600;

// -------------------- Share Feature

// When true, shows ✅ for correct answer in emoji meter
// When false, shows ◼️ (same as unused guesses) for correct answer
export const USE_ICON_FOR_CORRECT = false;

// Emoji icons for sharing
export const EMOJI = {
  TILE_REVEALED: '🟪',      // Purple square for revealed tiles
  INCORRECT_GUESS: '❌',     // Red X for incorrect guesses
  CORRECT_GUESS: '✅',      // Check mark for correct answer (when USE_ICON_FOR_CORRECT is true)
  UNUSED: '⬛',             // Black square for unused guesses
} as const;

// -------------------- Animation Timings (milliseconds)

export const ANIMATION = {
  // Tile animations
  TILE_FLIP_DURATION: 320,
  TILE_HOVER_DURATION: 200,

  // Input feedback
  INCORRECT_FEEDBACK_DURATION: 1500,
  SHAKE_DURATION: 100,
  SHAKE_DISTANCE: 12,
  SHAKE_TIMES: 3,
  SHAKE_SPEED: 1.65,

  // Toast animations
  TOAST_FADE_IN: 300,
  TOAST_FADE_OUT: 250,

  // Game over
  GAME_OVER_FADE_TILES_DUR: 0.2,
  GAME_OVER_FADE_TILES_GAP_DUR: 0.05,
  GAME_OVER_SOUNDWAVE_DUR: 1.25,

  // Autocomplete
  AUTOCOMPLETE_FADE: 150,
  AUTOCOMPLETE_HEIGHT: 250,
  AUTOCOMPLETE_BLUR_DELAY: 200,
} as const;

// -------------------- Warble Effect Configuration

export const WARBLE = {
  MAX_STRENGTH: 30,
  DURATION: 1200,
  BASE_FREQ_X: 0.018,
  BASE_FREQ_Y: 0.004,
  FREQ_VARIATION_X: 0.005,
  FREQ_VARIATION_Y: 0.002,
  FREQ_TIME_MULTIPLIER_X: 1.2,
  FREQ_TIME_MULTIPLIER_Y: 0.8,
  NOISE_INTENSITY: 0.003,
  FREQ_CHANGE_STEPS: 8,
  OCTAVES: 2,
} as const;
